// redux/slices/pushNotificationThunks.js
"use client";

import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getServerUrl, getAuthHeaders } from "../../Utils/serverSelector";

/* ============== HELPERS ============== */

const authJsonConfig = async () => {
  const headers = await getAuthHeaders();
  return {
    headers,
    withCredentials: true,
    validateStatus: () => true,
  };
};

/* ============== THUNKS ============== */

// Приватная отправка push (через JWT / приватный API)
export const sendPushNotification = createAsyncThunk(
  "notifications/sendPushNotification",
  async ({ token, title, body, screen, data = {} }, { rejectWithValue }) => {
    try {
      if (!token) throw new Error("Expo push token не передан");

      const cfg = await authJsonConfig();
      const base = (getServerUrl() || "").replace(/\/$/, "");

      const res = await axios.post(
        `${base}/push-notification`,
        { token, title, body, screen, data },
        cfg
      );

      if (res.status !== 200) {
        throw new Error(
          res.data?.message ||
            res.data?.error ||
            `Failed to send push (HTTP ${res.status})`
        );
      }

      return res.data;
    } catch (e) {
      return rejectWithValue(
        e?.response?.data?.error ||
          e?.response?.data?.message ||
          e?.message ||
          "Failed to send push"
      );
    }
  }
);

// Публичная отправка push (без JWT, для публичных форм/линков)
export const sendPublicPushNotification = createAsyncThunk(
  "notifications/sendPublicPushNotification",
  async ({ token, title, body, screen, data = {} }, { rejectWithValue }) => {
    try {
      if (!token) throw new Error("Expo push token не передан");

      const base = (getServerUrl() || "").replace(/\/$/, "");

      const res = await axios.post(
        `${base}/public/push-notification`,
        { token, title, body, screen, data },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          validateStatus: () => true,
        }
      );

      if (res.status !== 200) {
        throw new Error(
          res.data?.message ||
            res.data?.error ||
            `Failed to send public push (HTTP ${res.status})`
        );
      }

      return res.data;
    } catch (e) {
      return rejectWithValue(
        e?.response?.data?.error ||
          e?.response?.data?.message ||
          e?.message ||
          "Failed to send push"
      );
    }
  }
);
